<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="storeMsgManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="storeMsgManageInfo.conditions.title" placeholder="请输入通知名称" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryStoreMsgMethod">
              <i class="el-icon-search"></i> 查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>店铺通知</span>
        <el-button type="primary" size="small" style="float: right;" @click="_openAddStoreMsgModal">
          <i class="el-icon-plus"></i>发布
        </el-button>
      </div>
      <div class="">
        <el-table :data="storeMsgManageInfo.storeMsgs" border style="width: 100%">
          <el-table-column prop="msgId" label="消息ID" align="center" />
          <el-table-column prop="title" label="通知名称" align="center" />
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditStoreMsgModel(scope.row)">修改</el-button>
              <el-button size="mini" type="danger" @click="_openDeleteStoreMsgModel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="storeMsgManageInfo.total" layout="total, prev, pager, next, jumper" style="margin-top: 20px;" />
      </div>
    </el-card>

    <add-store-msg ref="addStoreMsg" @refresh="_queryStoreMsgMethod" />
    <edit-store-msg ref="editStoreMsg" @refresh="_queryStoreMsgMethod" />
    <delete-store-msg ref="deleteStoreMsg" @refresh="_queryStoreMsgMethod" />
  </div>
</template>

<script>
import { listShopMsg } from '@/api/storeMsgApi'
import { getShopId } from '@/api/shop/shopApi'
import { getDict } from '@/api/shop/shopApi'
import AddStoreMsg from '@/components/addStoreMsg/addStoreMsg'
import EditStoreMsg from '@/components/editStoreMsg/editStoreMsg'
import DeleteStoreMsg from '@/components/deleteStoreMsg/deleteStoreMsg'

export default {
  name: 'StoreMsgManage',
  components: {
    AddStoreMsg,
    EditStoreMsg,
    DeleteStoreMsg
  },
  data() {
    return {
      storeMsgManageInfo: {
        storeMsgs: [],
        total: 0,
        records: 1,
        moreCondition: false,
        msgId: '',
        msgFlags: [],
        conditions: {
          title: '',
          msgFlag: '',
          msgId: '',
          shopId: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listStoreMsgs(this.currentPage, this.pageSize)
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const { data } = await getDict('store_msg', 'msg_flag')
        this.storeMsgManageInfo.msgFlags = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listStoreMsgs(page, rows) {
      this.storeMsgManageInfo.conditions.page = page
      this.storeMsgManageInfo.conditions.row = rows
      this.storeMsgManageInfo.conditions.shopId = getShopId()

      try {
        const res = await listShopMsg(this.storeMsgManageInfo.conditions)
        this.storeMsgManageInfo.total = res.total
        this.storeMsgManageInfo.records = res.records
        this.storeMsgManageInfo.storeMsgs = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listStoreMsgs(val, this.pageSize)
    },
    _openAddStoreMsgModal() {
      this.$refs.addStoreMsg.open()
    },
    _openEditStoreMsgModel(row) {
      this.$refs.editStoreMsg.open(row)
    },
    _openDeleteStoreMsgModel(row) {
      this.$refs.deleteStoreMsg.open(row)
    },
    _queryStoreMsgMethod() {
      this.currentPage = 1
      this._listStoreMsgs(this.currentPage, this.pageSize)
    },
    _resetStoreMsgMethod() {
      console.log(this.storeMsgManageInfo.moreCondition)
      this.storeMsgManageInfo.conditions.title = ''
      this.storeMsgManageInfo.conditions.msgFlag = ''
      this.storeMsgManageInfo.conditions.msgId = ''
      this._listStoreMsgs(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>